module.exports = {
      id: "kishoralo-usage",
      viewBox: "0 0 512 209.434",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#kishoralo",
      toString: function () {
        return this.url;
      }
    }